<template>
  <div class="bkzx-detail-container">
    <div class="noStuClass" v-if="isNoStu">
      <img src="@/assets/img/qietu/noStu.png" alt="">
      <p>未找到该期刊</p>
    </div>
    <div v-else>
      <SubHeader :activeId="activeId" :subList="navList" :personalObject="personal" @changeNav="changeNav" />
      <div class="bkzx-content">
        <div class="content">
          <components :is="isShow"></components>
          <!-- <router-view></router-view> -->
        </div>
        <div class="bkzx-side">
          <div class="info-wrapper">
            <div v-if="personal.publishCompanyList && personal.publishCompanyList.length > 0">
              <p
                v-for="item in personal.publishCompanyList"
                :key="item.orgId"
              >
                出版单位：<span class="bkzxStatus" @click="handleClick(item.orgId, item.orgStatus)">{{ item.orgName }}</span>
              </p>
            </div>
            <p v-else>出版单位：{{personal.publishCompany}}</p>
            <p>出版周期 : {{ personal.publishPeriod | period }}</p>
            <p class="websites">
              收录网站：<span v-for="v in personal.pd" :key="v.id">{{
                v.name
              }}</span>
            </p>
            <p>国内邮发代号：{{ personal.codeDomestic }}</p>
            <p>出版地：{{ personal.publishAddrProvince }} <span v-if="personal.publishAddrCity"> - </span>{{ personal.publishAddrCity }}</p>
            <p>CN : {{ personal.cn }}</p>
            <p>ISSN：{{ personal.issn }}</p>
            <p>Email：{{ personal.email }}</p>
            <!-- <p>官方网址：{{ personal.website }}</p> -->
          </div>
          <BestArticle
            class="blog-container"
            title="近期最佳文章"
            :contentList="blogList"
          ></BestArticle>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from "@/components/pager/SubHeader";
import BestArticle from "@/components/pager/BestArticle.vue";
import Main from "./view/Main.vue";
import Blog from "./view/Blog.vue";
import Paper from "./view/Paper.vue";
import Zgh from "./view/Zgh.vue";
// import BkVideo from "./view/BkVideo.vue";
// import BkMonograph from "./view/BkMonograph.vue";
import Meeting from "./view/Meeting.vue";
import Course from "./view/Course.vue";
export default {
  components: {
    SubHeader,
    BestArticle,
  },
  filters: {
    period(num) {
      if (num == 1) {
        return `年刊`;
      } else if (num == 2) {
        return `半年刊`;
      } else if (num == 3) {
        return `季刊`;
      } else if (num == 4) {
        return `双月刊`;
      } else if (num == 5) {
        return `月刊`;
      } else if (num == 6) {
        return `半月刊`;
      } else if (num == 7) {
        return `旬刊`;
      } else if (num == 8) {
        return `周刊`;
      } else if (num == 9) {
        return `周二刊`;
      } else {
        return ``;
      }
      // 1 年刊 2半年刊 3 季刊 4 双月刊 5 月刊 6 半月刊 7 旬刊 8 周刊 9 周二刊
    },
  },
  data() {
    return {
      isShow: Main,
      isNoStu: false,
      activeId: 0,
      navList: [
        {
          title: "主页",
          name: Main,
          id: 0,
        },
        {
          title: "资讯",
          name: Blog,
          id: 1,
        },
        // {
        //   title: "视频",
        //   name: BkVideo,
          // id: 2,
        // },
        {
          title: "论文",
          name: Paper,
          id: 3,
        },
        // {
        //   title: "专著",
        //   name: BkMonograph,
          // id: 4,
        // },
        {
          title: "征稿函",
          name: Zgh,
          id: 5,
        },
        {
          title: "会议",
          name: Meeting,
          id: 6,
        },
        {
          title: "课程",
          name: Course,
          id: 7,
        },
      ],
      personal: {},
      blogList: [],
    };
  },
  created() {
    const id = this.getQueryVariable('id')
      this.getReadRankingList({
        id,
        pageNo: 1,
        pageSize: 5,
        userType: 1,
      }); //近期最佳文章
      this.bkDetailList({
        id,
      });
      
    // })
  },
  methods: {
    // 获取路径上的参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
              var pair = vars[i].split("=");
              if(pair[0] == variable){return pair[1];}
      }
      return(false);
    },
    changeNav(name,id) {
      this.activeId = id
      this.isShow = name
    },
    handleClick(id, status) {
      let routeUrl = this.$router.resolve({
        path: "/recommend",
        query: {
          id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    async getReadRankingList(data) {
      const resp = await this.$apis.hundredServe.getReadRankingList(data);
      this.blogList = resp.data.list;
    },
    async bkDetailList(data) {
      // 重新加密
      if (sessionStorage.getItem("trip") == null) {
        let { pk } = await this.$apis.mainServe.getPk();
        sessionStorage.setItem("trip", pk);
      }
      const resp = await this.$apis.recomendServe.periodical(data);
      document.title = resp.content.periodicalInfo.name + ' - 中文知识网'
      if (resp.resultCode === '1008') {
        this.isNoStu = true
      } else if (resp.content.periodicalInfo) {
        this.personal = resp.content.periodicalInfo
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.noStuClass {
  padding-top: 200px;
  width: 100%;
  height: 729px;
  background-color: #fff;
  border: 1px solid #A3CBE7;
  border-radius: 10px;
  text-align: center;
  img {
    width: 279px;
    height: 234px;
  }
  p {
    margin-top: 10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.bkzx-content {
  // position: absolute;
  // top: 365px;
  margin-top: 255px;
  margin-bottom: 10px;
  display: flex;
  .content {
    width: 886px;
    margin-bottom: 16px;
    margin-right: 9px;
  }
}
.footer {
  margin-top: 30px;
  text-align: center;
  color: #ccc;
}
.bkzx-side {
  width: 295px;
  .info-wrapper {
    width: 295px;
    // min-height: 320px;
    background-color: #fff;
    margin-bottom: 8px;
    // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
    padding: 0 30px 30px;
    line-height: 2;
    .bkzxStatus {
      cursor: pointer;
      &.status {
        cursor: text;
      }
    }
    .websites {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      span {
        margin: 0 5px;
      }
    }
  }
  .blog-container {
    background-color: #fff;
  }
}
</style>
